export interface GenericNote {
  id: string;
  title: string;
  description: string;
  lastUpdate: number;
  refId: string;
  /** NUll means system */
  userId: string | null;
  /** Persisted display name, used when the author is no longer available in the current context. */
  authorName?: string;
}

export enum NoteType {
  AGREEMENT = 'agreement',
  LANDLORD = 'landlord',
  DEFECT = 'defect',
  ISSUE = 'residentIssue',
  ESTATE = 'estate',
  SUBCONTRACTOR = 'subcontractor',
  UNIT = 'unit',
  CONCIERGE = 'concierge',
  OFFER_MEMBER = 'offerMember'
}
